import React from 'react';
import { useAppTheme } from '../Hooks/useAppTheme';

export const TopInfoCard = ({ icon, title, value, action, routeToPage, onActionClick }) => {
  const theme = useAppTheme();
  
  const handleClick = () => {
    if (onActionClick && routeToPage) {
      onActionClick(routeToPage);
    }
  };
  
  return (
    <div className="relative rounded-xl shadow p-4 pt-6 flex flex-col justify-between w-full overflow-visible" style={{ backgroundColor: theme.bgCard, boxShadow: theme.shadowCard }}>
      
      {/* Floating Icon */}
      <div className="absolute -top-4 left-4 rounded-md p-4 shadow-xl" style={{ background: theme.iconBg, color: theme.iconText }}>
        <div className="text-sm">{icon}</div>
      </div>

      {/* Title */}
      <div className="text-sm font-medium text-right" style={{ color: theme.textSecondary }}>{title}</div>

      {/* Value */}
      <div className="text-right text-2xl font-bold my-3" style={{ color: theme.textPrimary }}>{value}</div>

      {/* Action */}
      {action && (
        <div
          className="text-sm font-medium cursor-pointer hover:underline text-right"
          style={{ color: theme.brandAccent }}
          onClick={handleClick}
        >
          {action}
        </div>
      )}
    </div>
  );
};
